var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("AppInputField", {
    attrs: {
      id: _vm.id,
      name: _vm.name,
      label: _vm.label,
      "left-icon": _vm.leftIcon,
      placeholder: _vm.placeholder,
      value: _vm.value,
      disabled: _vm.disabled,
      readonly: _vm.readonly,
      "is-loading": _vm.isLoading,
      required: _vm.required,
      pattern: _vm.pattern,
      "error-message": _vm.errorMessage
    },
    on: { input: _vm.onInput, change: _vm.onChange }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }